import { Translations } from "@salaxy/core";
import { SafeString } from "handlebars";
import HbsRuntime from "handlebars/runtime";

/**
 * Helper for translating provided keys
 * @param lang Language used in translation
 * @param key Translation key
 * @param options Interpolate params options
 * @returns Return translated text as string or Hbs.SafeString if translation contains html
 */
export function hbsHelperT(lang: string, key: string, options: any): string | SafeString {
  const stringEndsWith = (s, suffix) => s && s.indexOf(suffix, s.length - suffix.length) !== -1;
  const params = options && options.hash ? options.hash : options;
  const result = Translations.get(key, params, lang);
  const text = stringEndsWith(key, ".html") ? new HbsRuntime.SafeString(result) : result;
  return text;
}